import React from "react";
import { Droppable } from "react-beautiful-dnd";
import { Link } from "react-router-dom";

export default function TasksContainer(props) {
   const { date, tasks, user, users, selectedProductKey, prevPath, copyScheduleMode } = props;

   return (
      <Droppable droppableId={`task-container_${date}_${user.id}`}>
         {(provided, snapshot) => (
            <td
               ref={provided.innerRef}
               style={{ backgroundColor: snapshot.isDraggingOver && "#e0e0e0" }}
               className="tasks-container"
               valign="top"
               {...provided.droppableProps}
            >
               {copyScheduleMode ? (
                  <div className="add-task-link add-task-link__top">
                     <div className="p-3 overflow-auto">
                        {tasks}
                        {provided.placeholder}
                     </div>
                  </div>
               ) : (
                  <Link
                     className="add-task-link add-task-link__top"
                     to={{
                        pathname: "/tasks-scheduler/new",
                        state: { user, day: date, users, selectedProductKey, prevPath }
                     }}
                  >
                     <div className="p-3 overflow-auto">
                        {tasks}
                        {provided.placeholder}
                     </div>
                  </Link>
               )}
            </td>
         )}
      </Droppable>
   );
}
